module.exports = __webpack_public_path__ + "img/product-icon4.6f0efb36.png";